const rbacUtils = require('client/util/rbacUtils').default;
const PageNavigationUtil = require('client/util/PageNavigationUtil').default;

// Disable jQuery ajax() cache busting when running tests. This is done so that
// we can stub GET requests that match a specific endpoint without using
// regular expressions to match the URL. When cache busting is enabled jQuery
// adds  "_={timestamp}" to the GET parameters. As a result, to stub a GET
// request to specific URL the respondWith() method would need to be passed a
// regular expression. This change would affect more than 100 tests that were
// previously in the jumpcloud-shared-controsl repository. When those tests
// were in their own repository no global jQuery ajax setup occurred and thus
// cache busting was not enabled.
// SEE: https://api.jquery.com/jQuery.ajax/

const ajaxSetupOptions = {
  cache: typeof window.mocha !== 'undefined' ? true : false,
  statusCode: {
    401: function () {
      PageNavigationUtil.handle401();
    },

    403: function() {
      rbacUtils.handleForbidden403();
    }
  },
};

$.ajaxSetup(ajaxSetupOptions);
